import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators';
import { _CLASSES_STORE, MUTATIONS } from '../values/classes.values';
import { ClassesService } from '../services/classes.service';
import Vue from 'vue';

export const CLASSES_STORE = _CLASSES_STORE; 

@Module({ namespaced: true })
export class ClassesStore extends VuexModule {

  /* State */
  public classes: Array<Object> = [];
  public pagedClasses: Array<Object> = [];
  public classStudents: Array<Object> = [];
  public pagedOrganizationStudents: Array<Object> = [];
  public classTeachers: Array<Object> = [];
  public pagedOrganizationTeachers: Array<Object> = [];
  public classCourses: Array<Object> = [];
  public pagedOrganizationCourses: any = [];
  public pagedSharedCourseTeachers: any = [];
  public substituteTeacherCanEditClass: Map<number, boolean> = new Map<number, boolean>();
  public classSchedule: any = { isAbleToEdit: false };


  /* Mutations */
  @Mutation
  public setAllClassesM(classes){
    this.classes = classes
  }

  @Mutation
  public setPagedClassesM(classes) {
    let content = classes.content
    let page = classes.number
    this.pagedClasses = [...this.pagedClasses, {page, content}]
  }

  @Mutation
  public clearPagedClassesM() {
    this.pagedClasses = []
  }

  @Mutation
  public setClassStudentsM(students: Array<Object>) {
    this.classStudents = students
  }

  @Mutation
  public setPagedOrganizationStudentsM(students) {
    let content = students.content
    let page = students.number
    this.pagedOrganizationStudents = [...this.pagedOrganizationStudents, {page, content}]
  }

  @Mutation
  public clearStudentsM() {
    this.classStudents = []
    this.pagedOrganizationStudents = []
  }

  @Mutation
  public setClassTeachersM(teachers) {
    this.classTeachers = teachers.filter(el => el.type !== 'STUDENT')
  }

  @Mutation
  public setPagedOrganizationTeachersM(teachers) {
    let content = teachers.content
    let page = teachers.number
    this.pagedOrganizationTeachers = [...this.pagedOrganizationTeachers, {page, content}]
  }

  @Mutation
  public clearTeachersM() {
    this.classTeachers = []
    this.pagedOrganizationTeachers = []
  }

  @Mutation
  public addStudentToClassM(student: Object) {
    this.classStudents = this.classStudents.concat(student)
  }

  @Mutation
  public removeStudentFromClassM(studentId) {
    this.classStudents = this.classStudents.filter(el => el['id'] !== studentId)
  }

  @Mutation
  public addTeacherToClassM(teacher: Object) {
    let obj = {person: teacher[0], type: 'CO_INSTRUCTOR'}
    this.classTeachers = this.classTeachers.concat(obj)
  }

  @Mutation
  public removeTeacherFromClassM(teacherId) {
    this.classTeachers = this.classTeachers.filter(el => el['person']['id'] !== teacherId)
  }

  @Mutation
  public setClassCoursesM(courses: Array<Object>) {
    this.classCourses = courses
  }

  @Mutation
  public addCourseToClassM(courses:  any[]) {
    courses.forEach(course =>{
      if(course.contentId)
        course = {
          ...course, 
          id: course.contentId,
          title: course.contentTitle
        }
        this.classCourses.unshift(course);
    })
  }

  @Mutation
  public updateCourseInClassM(course: any) {
    course = {
      ...course, 
      id: course.contentId,
      title: course.contentTitle
    }
    this.classCourses = this.classCourses.map(el => {
      if(el['id'] === course.id) {  
        return {...course, 
          courseTeachers: el['courseTeachers'], 
          locked: el['locked'],
          hasSchedule: el['hasSchedule'], 
          originTool: el['originTool'],
          syncStatus: el['syncStatus'],
          hasLocalBuilder: el['hasLocalBuilder']
        } ;
      } else return el;
    });
  }

  @Mutation
  public removeCourseFromClassM(courseId) {
    this.classCourses = this.classCourses.filter(el => el['id'] !== courseId)
  }

  @Mutation
  public setPagedOrganizationCoursesM(courses) {
    let content = courses.content
    let page = courses.number
    this.pagedOrganizationCourses = [...this.pagedOrganizationCourses, {page, content}]
  }

  @Mutation
  public clearCoursesM() {
    this.classCourses = []
    this.pagedOrganizationCourses = []
  }

  @Mutation
  public updateMainTeacherM({response, classId, prevMainTeacher}) {
    this.classTeachers = this.classTeachers.map(el => {
      if (response.id === el['person'].id) return { ...el, type: 'TEACHER' }
      else if (prevMainTeacher === el['person'].id) return { ...el, type: 'CO_INSTRUCTOR' }
      else return el
    })
    this.pagedClasses.forEach(page => {
     this.pagedClasses[page['page']]['content'] = page['content'].map(el => {
        if (el['id'] === classId) return { ...el, teacher: response }
        else return el
      })
    })
  }

  @Mutation
  public updateCourseConfigM({data, courseId}) {
    this.classCourses = this.classCourses.map(el => {
      if(el['id'] === courseId) el['courseTeachers'] = data.map(el => el.person)
      return el
    })
  }

  @Mutation
  public updateCourseOwnerM({response, courseId}) {
    this.pagedSharedCourseTeachers = this.pagedSharedCourseTeachers.map(el => {
      return { ...el, content: el.content.map(i => {
        if(i.access === 'OWNER') 
          return {...i, access: 'CO-EDITOR'}
        else if (i.id === response.id) 
          return {...i, access: 'OWNER'}
        else return i
      })}
    })
    
    this.classCourses = this.classCourses.map(el => {
      if (courseId === el['id']) return { ...el, owner: response }
      else return el
    })

    if (this.pagedOrganizationCourses.length > 0)
      this.pagedOrganizationCourses = []
  }

  @Mutation
  public shareCourseM({personId, page}) {
    this.pagedSharedCourseTeachers[page]['content'] = this.pagedSharedCourseTeachers[page]['content'].map(el => {
      if (personId === el['id']) return { ...el, access: 'CO-EDITOR' }
      else return el
    })
  }

  @Mutation
  public unshareCourseM({personId, page}) {
    this.pagedSharedCourseTeachers[page]['content'] = this.pagedSharedCourseTeachers[page]['content'].map(el => {
      if (personId === el['id']) return { ...el, access: '' }
      else return el
    })
  }

  @Mutation
  public blockCourseM(courseId) {
    this.classCourses = this.classCourses.map(el => {
      if (courseId === el['id']) return { ...el, locked: true }
      else return el
    })
    if (this.pagedOrganizationCourses.length > 0)
      this.pagedOrganizationCourses = []
  }

  @Mutation
  public unblockCourseM(courseId) {
    this.classCourses = this.classCourses.map(el => {
      if (courseId === el['id']) return { ...el, locked: false }
      else return el
    })
    if (this.pagedOrganizationCourses.length > 0)
      this.pagedOrganizationCourses = []
  }

  @Mutation
  public getSharedTeachersM(teachers) {
    let content = teachers.content
    let page = teachers.number
    this.pagedSharedCourseTeachers = [...this.pagedSharedCourseTeachers, {page, content}]
  }

  @Mutation
  public resetSharedTeachersM() {
    this.pagedSharedCourseTeachers = [];
  }

  @Mutation
  public canSubstituteTeacherEditClassM({classId, canEditClass}:{classId:number, canEditClass:boolean}) {
    if(!this.substituteTeacherCanEditClass.has(classId))
      this.substituteTeacherCanEditClass.set(classId, canEditClass)
  }

  @Mutation
  public updateClassNameM({ classId, className }): void {
    this.classes = this.classes.map(el => {
      return el['id'] == classId ? { ...el, name: className} : el;
    })
  }

  @Mutation
  public setClassScheduleM(classSchedule: any) {
    this.classSchedule= classSchedule;
  }

  /* Actions */
  @Action({rawError:true})
  public getAllClassesA(): Promise<any>{
    return new Promise((resolve,reject) => {
      ClassesService.getAllClasses().then((res:any) => {
          this.context.commit(MUTATIONS.SET_ALL_CLASSES_M, res);
          resolve(res);
        }).catch(err => {
          reject(err);
        });
    });
  }

  @Action({rawError:true})
  public createClassA(data): Promise<any>{
    return new Promise((resolve,reject) => {
      ClassesService.createClass(data).then((res:any) => {
        this.context.commit(MUTATIONS.CLEAR_CLASSES_M);
        resolve(res);
      }).catch(err => {
        reject(err);
      });
    });
  }

  @Action({rawError:true})
  public updateClassA({classId, body}:{classId:number,body:any}): Promise<any>{
    return new Promise((resolve,reject) => {
      ClassesService.updateClass(classId, body).then((res:any) => {
        this.context.commit(MUTATIONS.UPDATE_CLASS_NAME_M, {classId, className: body.name});
        resolve(res);
      }).catch(err => {
        reject(err);
      });
    });
  }

  @Action({rawError:true})
  public deleteClassA(classId: number): Promise<any>{
    return new Promise((resolve,reject) => {
      ClassesService.deleteClass(classId).then((res:any) => {
        this.context.commit(MUTATIONS.CLEAR_CLASSES_M);
        resolve(res);
      }).catch(err => {
        reject(err);
      });
    });
  }

  @Action({rawError:true})
  public inactivateClassA(classId: number): Promise<any>{
    return new Promise((resolve,reject) => {
      ClassesService.inactivateClass(classId).then((res:any) => {
        this.context.commit(MUTATIONS.CLEAR_CLASSES_M);
        resolve(res);
      }).catch(err => {
        reject(err);
      });
    });
  }
  

  @Action({rawError:true})
  public getClassesByDepartmentA({
    departmentId,
    sortBy = 'CLASS',
    page = 0,
    pageSize = 10
  }:{
    departmentId:number,
    sortBy:string,
    page:number,
    pageSize:number
  }): Promise<any>{
    return new Promise((resolve,reject) => {
      ClassesService.getClassesByDepartment(departmentId,page,pageSize,sortBy).then((res:any) => {
        this.context.commit(MUTATIONS.SET_CLASSES_M, res);
        resolve(res);
      }).catch(err => {
        reject(err);
      });
    });
  }

  @Action({rawError:true})
  public getStudentsByClassA({classId}:{classId:number}): Promise<any>{
    return new Promise((resolve,reject) => {
      ClassesService.getStudentsByClassId(classId).then((res:any) => {
        this.context.commit(MUTATIONS.SET_CLASS_STUDENTS_M, res.content);
          resolve(res);
        }).catch(err => {
          reject(err);
        });
    });
  }

  @Action({rawError:true})
  public getStudentsByOrganizationA({orgId,orderByClassId,page=0,pageSize=10}:{orgId:number,orderByClassId:number,page:number,pageSize:number}): Promise<any>{
    return new Promise((resolve,reject) => {
      ClassesService.getStudentsByOrganizationId(orgId,orderByClassId,page,pageSize).then((res:any) => {
        this.context.commit(MUTATIONS.SET_ORGANIZATION_STUDENTS_M, res);
          resolve(res);
        }).catch(err => {
          reject(err);
        });
    });
  }

  @Action({rawError:true})
  public getTeachersByClassA({classId}:{classId:number}): Promise<any>{
    return new Promise((resolve,reject) => {
      ClassesService.getTeachersByClassId(classId).then((res:any) => {
        this.context.commit(MUTATIONS.SET_CLASS_TEACHERS_M, res);
          resolve(res);
        }).catch(err => {
          reject(err);
        });
    });
  }

  @Action({rawError:true})
  public getTeachersByOrganizationA({orgId,orderByClassId,page=0,pageSize=10}:{orgId:number,orderByClassId:number,page:number,pageSize:number}): Promise<any>{
    return new Promise((resolve,reject) => {
      ClassesService.getTeachersByOrganizationId(orgId,orderByClassId,page,pageSize).then((res:any) => {
        this.context.commit(MUTATIONS.SET_ORGANIZATION_TEACHERS_M, res);
          resolve(res);
        }).catch(err => {
          reject(err);
        });
    });
  }

  @Action({rawError:true})
  public getCoursesByClassA({classId, typesContent = 'CS,CSQ', builderContent}:{classId:number, typesContent: string, builderContent?: Array<any>}): Promise<any>{
    return new Promise((resolve,reject) => {
      ClassesService.getCoursesByClassId(classId, typesContent, builderContent).then((res:any) => {
        this.context.commit(MUTATIONS.SET_CLASS_COURSES_M, res);
          resolve(res);
        }).catch(err => {
          reject(err);
        });
    });
  }

  @Action({rawError:true})
  public getCoursesByOrganizationA({orgId,orderByClassId,page=0,pageSize=10}:{orgId:number,orderByClassId:number,page:number,pageSize:number}): Promise<any>{
    let body = {
      page,
      pageSize,
      orderByClassId
    }
    return new Promise((resolve,reject) => {
      ClassesService.getCoursesByOrganizationId(orgId,body).then((res:any) => {
        this.context.commit(MUTATIONS.SET_ORGANIZATION_COURSES_M, res);
        resolve(res);
      }).catch(err => {
        reject(err);
      });
    });
  }

  @Action({rawError:true})
  public addStudentToClassA(data): Promise<any>{
    let body = { 'personIds': [data.studentId] }
    return new Promise((resolve,reject) => {
      ClassesService.addStudentToClass(data.classId, body).then((res:any) => {
        this.context.commit(MUTATIONS.ADD_STUDENT_TO_CLASS_M, res );
        resolve(res);
      }).catch(err => {
        reject(err);
      });
    });
  }

  @Action({rawError:true})
  public removeStudentFromClassA(data): Promise<any>{
    let body = { 'personIds': [data.studentId] }
    return new Promise((resolve,reject) => {
      ClassesService.removeStudentFromClass(data.classId, body).then((res:any) => {
        this.context.commit(MUTATIONS.REMOVE_STUDENT_FROM_CLASS_M, data.studentId );
        resolve(res);
      }).catch(err => {
        reject(err);
      });
    });
  }

  @Action({rawError:true})
  public addTeacherToClassA(data): Promise<any>{
    let body = { 'personIds': [data.teacherId]}
    return new Promise((resolve,reject) => {
      ClassesService.addTeacherToClass(data.classId, body).then((res:any) => {
        this.context.commit(MUTATIONS.ADD_TEACHER_TO_CLASS_M, res );
        resolve(res);
      }).catch(err => {
        reject(err);
      });
    });
  }

  @Action({rawError:true})
  public removeTeacherFromClassA(data): Promise<any>{
    let body = { 'personIds': [data.teacherId] }
    return new Promise((resolve,reject) => {
      ClassesService.removeTeacherFromClass(data.classId, body).then((res:any) => {
        this.context.commit(MUTATIONS.REMOVE_TEACHER_FROM_CLASS_M, data.teacherId );
        resolve(res);
      }).catch(err => {
        reject(err);
      });
    });
  }

  @Action({rawError:true})
  public addCourseToClassA(data): Promise<any>{    
    let body = { 'contentIds': [data.courseId] }
    return new Promise((resolve,reject) => {
      ClassesService.addCourseToClass(data.classId, body).then((res:any) => {
        this.context.commit(MUTATIONS.ADD_COURSE_TO_CLASS_M, res);
        resolve(res);
      }).catch(err => {
        reject(err);
      });
    });
  }

  @Action({rawError:true})
  public removeQuickContentA({quickContentId, classId}): Promise<any>{
    return new Promise((resolve,reject) => {
      ClassesService.removeQuickContent(quickContentId, classId).then((res:any) => {
        this.context.commit(MUTATIONS.REMOVE_COURSE_FROM_CLASS_M, quickContentId );
        resolve(res);
      }).catch(err => {
        reject(err);
      });
    });
  }

  @Action({rawError:true})
  public removeCourseFromClassA(data): Promise<any>{
    let body = { 'contentIds': [data.courseId] }
    return new Promise((resolve,reject) => {
      ClassesService.removeCourseFromClass(data.classId, body).then((res:any) => {
        this.context.commit(MUTATIONS.REMOVE_COURSE_FROM_CLASS_M, data.courseId );
        resolve(res);
      }).catch(err => {
        reject(err);
      });
    });
  }

  @Action({rawError:true})
  public removeQuickSubjectFromClassA(data): Promise<any>{
    return new Promise((resolve,reject) => {
      ClassesService.removeQuickContent(data.quickContentId, data.classId).then((res:any) => {
        this.context.commit(MUTATIONS.REMOVE_COURSE_FROM_CLASS_M, data.courseId );
        resolve(res);
      }).catch(err => {
        reject(err);
      });
    });
  }

  @Action({rawError:true})
  public removeCourseTeacherFromClassA(data): Promise<any>{
    let body = { 'personIds': [data.teacherId] }
    return new Promise((resolve,reject) => {
      ClassesService.removeCourseTeacherFromClass(data.classId, body).then((res:any) => {
        this.context.commit(MUTATIONS.REMOVE_TEACHER_FROM_CLASS_M, data.teacherId );
        resolve(res);
      }).catch(err => {
        reject(err);
      });
    });
  }

  @Action({rawError:true})
  public updateMainTeacherA(data): Promise<any>{
    return new Promise((resolve,reject) => {
      ClassesService.updateMainTeacher(data.classId, data.teacherId).then((res:any) => {
        this.context.commit(MUTATIONS.UPDATE_MAIN_TEACHER_M, {response: res, classId: data.classId, prevMainTeacher: data.prevMainTeacher});
        resolve(res);
      }).catch(err => {
        reject(err);
      });
    });
  }

  @Action({rawError:true})
  public searchUsersOrganizationA({orgId, keyword = '', userTypes = ''}:{orgId:number, keyword: string, userTypes: string}): Promise<any>{
    return new Promise((resolve,reject) => {
      ClassesService.searchUsersInOrganization(orgId, keyword, userTypes).then((res:any) => {
        resolve(res);
      }).catch(err => {
        reject(err);
      });
    });
  }

  @Action({rawError:true})
  public searchCoursesByOrganizationA({orgId,orderByClassId,page=0,pageSize=-1,keyword=''}:{orgId:number,orderByClassId:number,page:number,pageSize:number,keyword:string}): Promise<any>{
    let body = {
      page,
      pageSize,
      keyword,
      orderByClassId
    }
    return new Promise((resolve,reject) => {
      ClassesService.getCoursesByOrganizationId(orgId,body).then((res:any) => {
        resolve(res);
      }).catch(err => {
        reject(err);
      });
    });
  }

  @Action({rawError:true})
  public updateCourseConfigA({classId, courseId, data}:{classId:number,courseId:number,data:object[]}): Promise<any>{
    return new Promise((resolve,reject) => {
      ClassesService.updateCourseConfig(classId, courseId, data).then((res:any) => {
        this.context.commit(MUTATIONS.UPDATE_COURSE_CONFIG_M, {data: res, courseId});
          resolve(res);
        }).catch(err => {
          reject(err);
        });
    });
  }

  @Action({rawError:true})
  public async updateCourseOwnerA(data){
    let res = data.isTemplate ? 
      await Vue.prototype.$CourseTemplates.Services.updateOwnerTemplate(data.courseId, data.ownerId)
      : await ClassesService.updateCourseOwner(data.courseId, data.ownerId);
    this.context.commit(MUTATIONS.UPDATE_COURSE_OWNER_M, {response: res, courseId: data.courseId });
  }

  @Action({rawError:true})
  public async shareCourseA(data) {
    data.isTemplate ? 
      await Vue.prototype.$CourseTemplates.Services.shareCourseTemplate(data.courseId, data.personId)
      : await ClassesService.shareCourse(data.courseId, data.personId);
    this.context.commit(MUTATIONS.SHARE_COURSE_M, { personId: data.personId, page: data.page });
  }

  @Action({rawError:true})
  public async unshareCourseA(data) {
    data.isTemplate ? 
      await Vue.prototype.$CourseTemplates.Services.unshareCourseTemplate(data.courseId, data.personId)
      : await ClassesService.unshareCourse(data.courseId, data.personId);
    this.context.commit(MUTATIONS.UNSHARE_COURSE_M, { personId: data.personId, page: data.page});
  }

  @Action({rawError:true})
  public blockCourseA(data): Promise<any>{
    return new Promise((resolve,reject) => {
      ClassesService.blockCourse(data.courseId).then((res:any) => {
        this.context.commit(MUTATIONS.BLOCK_COURSE_M, data.courseId);
        resolve(res);
      }).catch(err => {
        reject(err);
      });
    });
  }

  @Action({rawError:true})
  public unblockCourseA(data): Promise<any>{
    return new Promise((resolve,reject) => {
      ClassesService.unblockCourse(data.courseId).then((res:any) => {
        this.context.commit(MUTATIONS.UNBLOCK_COURSE_M, data.courseId);
        resolve(res);
      }).catch(err => {
        reject(err);
      });
    });
  }

  @Action({rawError:true})
  public getSharedTeachersA({courseId,page=0,pageSize=10}:{courseId:number,page:number,pageSize:number}): Promise<any>{
    return new Promise((resolve,reject) => {
      ClassesService.getSharedTeachers(courseId,page,pageSize).then((res:any) => {
        this.context.commit(MUTATIONS.GET_SHARED_TEACHERS_M, res);
          resolve(res);
        }).catch(err => {
          reject(err);
        });
    });
  }

  @Action({rawError:true})
  public getStudentsByOrganizationAndClassA({orgId,classIds,personFilter,page=0,pageSize=10}:{orgId:number,classIds:string,personFilter:string,page:number,pageSize:number}): Promise<any>{
    return new Promise((resolve,reject) => {
      ClassesService.getStudentsByOrganizationIdAndClass(orgId,classIds,personFilter,page,pageSize).then((res:any) => {
        resolve(res);
      }).catch(err => {
        reject(err);
      });
    });
  }

  @Action({rawError:true})
  public getClassesByOrganizationA({orgId,userId,search,page=0,pageSize=10}:{orgId:number,userId:number,search:string,page:number,pageSize:number}): Promise<any>{
    return new Promise((resolve,reject) => {
      ClassesService.getClassesByOrganization(orgId,userId,search,page,pageSize).then((res:any) => {
        resolve(res);
      }).catch(err => {
        reject(err);
      });
    });
  }

  @Action({rawError:true})
  public async canSubstituteTeacherEditClassA({classId}:{classId:number}) {
    const canEditClass = await ClassesService.canSubstituteTeacherEditClassId(classId);
    this.context.commit(MUTATIONS.CAN_SUBSTITUTE_TEACHER_EDIT_CLASS_M, { classId, canEditClass });
  }

  @Action({rawError:true})
  public createQuickContentA({templateId,classId,schoolDay,subject,coverImage,automaticFolderType,componentsSelected = []}:
    {templateId:number,classId:number,schoolDay:any,subject:any,coverImage:any,automaticFolderType:any,componentsSelected:any}): Promise<any>{
    return new Promise((resolve,reject) => {
      ClassesService.createQuickContent({
        templateId, 
        classId,
        schoolDay, 
        subject, 
        coverImage, 
        automaticFolderType,
        componentsSelected
      }).then((res:any) => {
        this.context.commit(MUTATIONS.ADD_COURSE_TO_CLASS_M, [res]);
        resolve(res);
        }).catch(err => {
          reject(err);
        });
    });
  }

  @Action({rawError:true})
  public updateQuickContentA({quickContentId, templateId,classId,schoolDay,subject,coverImage,automaticFolderType,componentsSelected = []}:
    {quickContentId:number,templateId:number,classId:number,schoolDay:any,subject:any,coverImage:any,automaticFolderType:any,componentsSelected:any}): Promise<any>{
    return new Promise((resolve,reject) => {
      ClassesService.updateQuickContent({
        quickContentId,
        templateId, 
        classId,
        schoolDay, 
        subject, 
        coverImage, 
        automaticFolderType,
        componentsSelected
      }).then((res:any) => {
        this.context.commit(MUTATIONS.UPDATE_COURSE_IN_CLASS_M, res);
          resolve(res);
        }).catch(err => {
          reject(err);
        });
    });
  }

  @Action({rawError:true})
  public createSubjectForBuilderA({templateId,classId,schoolDay,subject,coverImage,automaticFolderType,componentsSelected = []}:
    {templateId:number,classId:number,schoolDay:any,subject:any,coverImage:any,automaticFolderType:any,componentsSelected:any}): Promise<any>{
    return new Promise((resolve,reject) => {
      ClassesService.createSubjectForBuilderA({
        templateId, 
        classId,
        schoolDay, 
        subject, 
        coverImage, 
        automaticFolderType,
        componentsSelected
      }).then((res:any) => {
        if(classId) this.context.commit(MUTATIONS.ADD_COURSE_TO_CLASS_M, res.content);
          resolve(res);
        }).catch(err => {
          reject(err);
        });
    });
  }

  /* Initial State */
  @Mutation
  public initState(state) {
    this.classes = [];
    this.pagedClasses = [];
    this.classStudents = [];
    this.pagedOrganizationStudents = [];
    this.classTeachers = [];
    this.pagedOrganizationTeachers = [];
    this.classCourses = [];
    this.pagedOrganizationCourses = [];
    this.pagedSharedCourseTeachers = [];
    this.substituteTeacherCanEditClass = new Map<number, boolean>();
    this.classSchedule = {isAbleToEdit: false};
  }

}
